import { getAutomationOverride } from "./automation/automationTags";

const isDebugNavigationEnabled = (params: URLSearchParams) => {
  const flag =
    params.get("debugNav") ??
    params.get("debugNavigation") ??
    params.get("debug") ??
    getAutomationOverride("navigation") ??
    getAutomationOverride("nav");

  if (!flag) {
    return false;
  }

  const normalized = String(flag).toLowerCase();
  return (
    normalized === "navigation" ||
    normalized === "nav" ||
    normalized === "1" ||
    normalized === "true"
  );
};

export const shouldDebugNavigation = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  return isDebugNavigationEnabled(params);
};

export const navLog = (scope: string, message: string, extra?: Record<string, unknown>) => {
  if (!shouldDebugNavigation()) {
    return;
  }
  // Keep payloads shallow so logs stay readable on mobile.
  if (extra) {
    console.info(`[nav][${scope}] ${message}`, extra);
  } else {
    console.info(`[nav][${scope}] ${message}`);
  }
};

export const navWarn = (scope: string, message: string, extra?: Record<string, unknown>) => {
  if (!shouldDebugNavigation()) {
    return;
  }
  if (extra) {
    console.warn(`[nav][${scope}] ${message}`, extra);
  } else {
    console.warn(`[nav][${scope}] ${message}`);
  }
};
